import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers([
  'control',
  'icon',
  'container',
  'label',
]);

const SelectionFieldSetting = definePartsStyle({
  control: defineStyle({
    _disabled: {
      background: 'unset',
      _hover: {
        background: 'unset',
      },
    },
  }),
});

export const Checkbox = defineMultiStyleConfig({
  baseStyle: {
    control: {
      border: '1px',
      borderColor: 'outline.gray',
      _hover: {
        bg: 'gray.50',
      },
    },
  },
  variants: {
    'selection-field-setting': SelectionFieldSetting,
  },
});
